/**
 * Access levels nest (F1:405271): owner > admin > user.
 * Single source for both the server (`requireRoleAtLeast`) and client
 * (`userHasRoleAtLeast`) "at least" checks — do not copy this table.
 */
export const accessLevelOrder = ['user', 'admin', 'owner'] as const
export type AccessLevel = (typeof accessLevelOrder)[number]

/** Roles that satisfy "at least `level`" — `level` itself and everything above. */
export function rolesAtLeast(level: string): Array<string> {
	const index = accessLevelOrder.indexOf(level as AccessLevel)
	if (index === -1) return [level]
	return accessLevelOrder.slice(index) as unknown as Array<string>
}
